import { render, staticRenderFns } from "./button.vue?vue&type=template&id=7df741f8&"
import script from "./button.vue?vue&type=script&lang=tsx&"
export * from "./button.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports